/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Utils')
    .directive('accFocusAndSelect', [ 
        function() {
            return {
                require: 'ngModel',
                link: function($scope, $element, $attrs) {
                    if (!angular.isDefined($attrs.autofocus)) {
                        throw new Error('Please provide autofocus attribute.');
                    }

                    $scope.$watch($attrs.ngModel, function() {
                        $element.select();
                    });
                }
            }
        }
    ]);
